/* eslint-disable */
import {put, takeEvery} from "redux-saga/effects";
import VideoEvents from "./VideoEvents";
import VideoApi from "./VideoApi";
import {Video} from "./models/Video";
import {
    addVideoReaction,
    addVideoReactionComplete,
    createVideo,
    createVideoComment,
    createVideoCommentComplete,
    createVideoComplete,
    deleteExtraMaterial,
    deleteVideo,
    incrementVideoViewCount,
    AddViewingHistory,
    loadVideoComplete,
    loadVideoList,
    loadVideoListComplete,
    loadVideoStarted,
    updateVideo,
    uploadExtraMaterial,
    uploadExtraMaterialComplete,
    filterVideoList,
    filterVideoListComplete,
    getTagList,
    getTagListComplete,
    AddVideo,
    AddVideoComplete,
    AddVideoFailed,
    EditVideo,
    EditVideoComplete,
    EditVideoFailed,
    UploadDocumentComplete,
    UploadDocumentFailed,
    DeleteVideo,
    DeleteVideoComplete,
    DeleteVideoFailed,
    GetVideoSlide,
    GetVideoSlideComplete,
    UploadVideoSlide,
    UploadVideoSlideComplete,
    EditVideoSlide,
    EditVideoSlideFailed,
    EditVideoSlideComplete,
    DeleteVideoSlide,
    DeleteVideoSlideFailed,
    DeleteVideoSlideComplete,
    GetVideoCurrentSubtitleStarted,
    GetVideoCurrentSubtitleComplete
} from "./VideoActions";
import {VideoReaction} from "./models/VideoReaction";
import {VideoComment} from "./models/VideoComment";
import {VideoExtraMaterial} from "./models/VideoExtraMaterial";
import {FilterResult} from "./models/VideoFilter";

function* loadAllWorker() {
    const videos: Video[] = yield VideoApi.getAll();
    yield put(loadVideoListComplete(videos));
}

function* loadVideoWorker({videoId, userId}: ReturnType<typeof loadVideoStarted>) {
    if (videoId && userId) {
        const video: Video = yield VideoApi.get(videoId, userId);
        console.log("single video:", video);
        yield put(loadVideoComplete(video));
   }
}

function* createVideoWorker({formData}: ReturnType<typeof createVideo>) {
    yield VideoApi.create(formData);
    yield put(createVideoComplete());
    // TODO consider making backend return something (video or at least ID)
    yield put(loadVideoList());
}

function* deleteVideoWorker({videoId}: ReturnType<typeof deleteVideo>) {
    yield VideoApi.delete(videoId);
}

function* updateVideoWorker({videoId, changeSet}: ReturnType<typeof updateVideo>) {
    yield VideoApi.update(videoId, changeSet);
}

function* uploadExtraMaterialWorker({videoId, formData}: ReturnType<typeof uploadExtraMaterial>) {
    const material: VideoExtraMaterial = yield VideoApi.uploadExtraMaterial(videoId, formData);
    yield put(uploadExtraMaterialComplete(material));
}

function* deleteExtraMaterialWorker({materialId}: ReturnType<typeof deleteExtraMaterial>) {
    yield VideoApi.deleteExtraMaterial(materialId);
}

function* addViewingHistoryWorker({userId, videoId, progressMillis}: ReturnType<typeof AddViewingHistory>) {
    yield VideoApi.addViewingHistory(userId, videoId, progressMillis);
}
function* IncrementVideoViewCountWorker({userId, videoId}: ReturnType<typeof incrementVideoViewCount>) {
    yield VideoApi.incrementViews(userId, videoId);
}

function* createVideoCommentWorker({videoCommentChangeSet}: ReturnType<typeof createVideoComment>) {
    const savedComment: VideoComment = yield VideoApi.createComment(videoCommentChangeSet);
    yield put(createVideoCommentComplete(savedComment));
}

function* createVideoReactionWorker({videoReactionChangeSet}: ReturnType<typeof addVideoReaction>) {
    const reaction: VideoReaction = yield VideoApi.createReaction(videoReactionChangeSet);
    yield put(addVideoReactionComplete(reaction));
}

function* loadfilteredVideoList({userId, filters}: ReturnType<typeof filterVideoList>) {
    const filterResult: FilterResult = yield VideoApi.getByFilter(userId, filters);
    console.log("filterResult :", filterResult);
    yield put(filterVideoListComplete(filterResult));
}

function* loadTagList({tagInput}: ReturnType<typeof getTagList>) {
    const filterResult: string[] = yield VideoApi.getTagList(tagInput);
    yield put(getTagListComplete(filterResult));
}

// ビデオ追加
function* AddVideoWorker({video}: ReturnType<typeof AddVideo>) {
    const addVideo: any = yield VideoApi.AddVideo(video);
    if(addVideo.response && addVideo.response.status !== 200){
        yield put(AddVideoFailed());
   }else{
        yield put(AddVideoComplete());
   }
}

// ビデオ編集
function* EditVideoWorker({editVideo}: ReturnType<typeof EditVideo>) {
    const updateVideo: any = yield VideoApi.EditVideo(editVideo);
    console.log("VideoSaga: EditVideoWorker", updateVideo);
    if(updateVideo.response && updateVideo.response.status !== 200){
        yield put(EditVideoFailed(editVideo.video.id));
   }
    else{
        if(editVideo.documentName.length > 0 || editVideo.materialId.length > 0){
            const updateVideoInfo: Video= updateVideo;
            const uploadDocument: any = yield VideoApi.UploadDocument({userId: editVideo.userId, videoId: updateVideoInfo.id, materialId: editVideo.materialId,  documentFile: editVideo.documentFile, documentName: editVideo.documentName});
            console.log("uploadDocument", uploadDocument);
            if(uploadDocument.response && uploadDocument.response.status !== 200){
                yield put(EditVideoComplete(updateVideo));
                yield put(UploadDocumentFailed());
           }
            else{
                yield put(EditVideoComplete(updateVideo));
                yield put(UploadDocumentComplete(uploadDocument));
           }
       }else{
            yield put(EditVideoComplete(updateVideo));
       }
   }
}

// ビデオ削除
function* DeleteVideoWorker({videoId}: ReturnType<typeof DeleteVideo>) {
    const response: any = yield VideoApi.DeleteVideo(videoId);
    console.log("VideoSaga: DeleteVideoWorker", response);
    if(response.response && response.response.status !== 200){
        yield put(DeleteVideoFailed());
   }
    else{
        yield put(DeleteVideoComplete());
   }
}

// ビデオスライド資料取得
function* GetVideoSlideWorker({videoId, fileId}: ReturnType<typeof GetVideoSlide>) {
    const response: any = yield VideoApi.GetVideoSlide(videoId, fileId);
    console.log("VideoSaga: GetVideoSlideWorker", response);
    yield put(GetVideoSlideComplete(response));
}

// ビデオスライド追加・編集・削除
function* UploadVideoSlideWorker({uploadVideoSlide}: ReturnType<typeof UploadVideoSlide>) {
    const response: any = yield VideoApi.UpdateVideoSlide(uploadVideoSlide);
    console.log("VideoSaga: UploadVideoSlideWorker", response);
    yield put(UploadVideoSlideComplete(response));
}

function* EditVideoSlideWorker({editVideoSlide}: ReturnType<typeof EditVideoSlide>) {
    const response: any = yield VideoApi.UpdateVideoSlide(editVideoSlide);
    console.log("VideoSaga: EditVideoSlideWorker", response);
    if(response.response && response.response.status !== 200){
        yield put(EditVideoSlideFailed());
   }else{
        yield put(EditVideoSlideComplete(editVideoSlide.videoId, response));
   }
}

function* DeleteVideoSlideWorker({videoId}: ReturnType<typeof DeleteVideoSlide>) {
    const response: any = yield VideoApi.DeleteVideoSlide(videoId);
    console.log("VideoSaga: DeleteVideoSlideWorker", response);
    if(response.response && response.response.status !== 200){
        yield put(DeleteVideoSlideFailed());
   }else{
        yield put(DeleteVideoSlideComplete(videoId));
   }
}

/**
 * 多言語の字幕情報取得
 * 
 * @param videoId ビデオID
 * @param language 言語
 */
function* GetVideoCurrentSubtitleWorker({videoId, language}: ReturnType<typeof GetVideoCurrentSubtitleStarted>) {
    const response: any = yield VideoApi.GetCurrentSubtitle(videoId, language);
    yield put(GetVideoCurrentSubtitleComplete(language, response));
}

export default function* VideoSaga() {
    yield takeEvery(VideoEvents.LoadVideoListStarted, loadAllWorker);
    yield takeEvery(VideoEvents.LoadVideoStarted, loadVideoWorker);
    yield takeEvery(VideoEvents.CreateStarted, createVideoWorker);
    yield takeEvery(VideoEvents.AddViewingHistory, addViewingHistoryWorker);
    yield takeEvery(VideoEvents.IncrementViewCount, IncrementVideoViewCountWorker);
    yield takeEvery(VideoEvents.Delete, deleteVideoWorker);
    yield takeEvery(VideoEvents.Update, updateVideoWorker);
    yield takeEvery(VideoEvents.UploadExtraMaterials, uploadExtraMaterialWorker);
    yield takeEvery(VideoEvents.DeleteExtraMaterials, deleteExtraMaterialWorker);
    yield takeEvery(VideoEvents.CommentStarted, createVideoCommentWorker);
    yield takeEvery(VideoEvents.ReactStarted, createVideoReactionWorker);
    yield takeEvery(VideoEvents.filterVideoListStarted, loadfilteredVideoList);
    yield takeEvery(VideoEvents.getTagListStarted, loadTagList);
    yield takeEvery(VideoEvents.AddVideoStarted, AddVideoWorker);
    yield takeEvery(VideoEvents.EditVideoStarted, EditVideoWorker);
    yield takeEvery(VideoEvents.DeleteVideoStarted, DeleteVideoWorker);
    yield takeEvery(VideoEvents.GetVideoSlide, GetVideoSlideWorker);
    yield takeEvery(VideoEvents.UploadVideoSlideStarted, UploadVideoSlideWorker);
    yield takeEvery(VideoEvents.EditVideoSlideStarted, EditVideoSlideWorker);
    yield takeEvery(VideoEvents.DeleteVideoSlideStarted, DeleteVideoSlideWorker);
    // 多言語の字幕情報取得タスク
    yield takeEvery(VideoEvents.GetVideoCurrentSubtitleStarted, GetVideoCurrentSubtitleWorker);
}
